import {
	Component,
	HostListener,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { defaultZero } from "@app/helpers"
import { Modalable } from "@app/Modalable"
import { environment } from "@env/environment"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { NgTemplateOutlet } from "@angular/common"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { ServerImgPipe } from "@app/utils/server-img.pipe"

@Component({
	selector: "app-image-gallery",
	imports: [COMMON_IMPORTS, ModalWrapComponent, DateFormatPipe, ServerImgPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-modal-wrap (onClose)="onClose.emit()">
			<h3 header>
				{{
					$safeNavigationMigration(images[curImagePosition]?.date) | dateFormat
				}}
			</h3>
			<div class="image-gallery">
				<div class="items">
					<!-- back btn - only visible if current pic isn't first -->
					@if (curImagePosition != 0) {
						<app-icon
							icon="arrow_left"
							(click)="move(false)"
							pointer
						/>
					}
				</div>
				@if (images.length) {
					<img
						[src]="images[curImagePosition].id | serverImg: 'followup-image'"
					/>
				}
				<div class="items">
					<!-- forward btn - only visible if current pic isn't last -->
					@if (curImagePosition != images.length - 1) {
						<app-icon
							icon="arrow_right"
							(click)="move(true)"
							pointer
						/>
					}
				</div>
			</div>
		</app-modal-wrap>
	`,
})
export class ImageGalleryComponent extends Modalable {
	@Input({ required: true }) images: any[] = [] //array of the images to display
	@Input({ transform: defaultZero }) curImagePosition: number = 0 //current images position

	move(isUp: boolean = true) {
		//move the current position (either add or subtract 1)
		// this.curImagePosition = (this.curImagePosition + this.images.length + (isUp ? 1 : -1)) % this.images.length;
		this.curImagePosition += isUp ? 1 : -1
	}
	ngOnInit() {
		this.images.forEach(({ id }) => {
			const img = new Image()
			img.src = `${environment.serverUrl}/followup-image/${id}`
		})
	}

	@HostListener("document:keydown", ["$event"]) //listen to keyboard events for left/right arrows
	onKeyDown(event: KeyboardEvent) {
		switch (event.key) {
			case "ArrowLeft": //on arrow left, if current position is not the last pic - move forward
				if (this.curImagePosition != this.images.length - 1) {
					this.move(true)
				}
				break
			case "ArrowRight": //on arrow right, if current position is not the first pic - move back
				if (this.curImagePosition != 0) {
					this.move(false)
				}
				break
		}
	}
}
